import Component, { mixins } from 'vue-class-component';

import { AxiosError, AxiosResponse } from "axios";

import { STORE_ACTIONS } from '@/store';
import EventBus from '@/EventBus';

import IInscriptionLieuExamenInformations from "./IInscriptionLieuExamenInformations.model";
import IDossierEtudiant from './IDossierEtudiant.model';
import IOverviewInscriptionOffreCours from './overview/IOverviewInscriptionOffreCours.model';
import ITypeInscriptionLieuExamen, { SLUGS as ITypeInscriptionLieuExamen_SLUGS } from './ITypeInscriptionLieuExamen.model'
import IFormInscriptionOffreCours from './form/IFormInscriptionOffreCours.model';

import BaseService from '../global/base/Base.service';

export enum EVENTS {
  AFTER_UPDATE = 'update:after'
}

export interface IUpdateInscriptionLieuExamenRequestPayload {
  idInscriptionLieuExamen: number;
  idTypeInscriptionLieuExamen: number;
  slugTypeInscriptionLieuExamen: ITypeInscriptionLieuExamen_SLUGS;
  idVille: number | null;
  paysRepondant: string | null;
  villeRepondant: string | null;
}

@Component
export default class InscriptionLieuExamenService extends mixins(BaseService) {
  protected service_inscriptionLieuExamenService_fetchInformations(): Promise<IInscriptionLieuExamenInformations> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get('/api/inscriptions-lieu-examen/informations')
        .then((response: AxiosResponse) => {
          const informations: IInscriptionLieuExamenInformations = response.data.data

          this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_STORE_INFORMATIONS, informations)

          resolve(informations)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }

  protected service_inscriptionLieuExamenService_fetchDossierEtudiant(token: string): Promise<IDossierEtudiant> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get(`/api/inscriptions-lieu-examen/dossier/${token}`)
        .then((response: AxiosResponse) => {
          const dossierEtudiant: IDossierEtudiant = response.data.data

          this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_STORE_DOSSIER_ETUDIANT, dossierEtudiant)

          resolve(dossierEtudiant)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }

  protected service_inscriptionLieuExamenService_fetchOverviewInscriptionsOffreCours(token: string): Promise<Array<IOverviewInscriptionOffreCours>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get(`/api/inscriptions-lieu-examen/dossier/${token}/apercu-inscriptions`)
        .then((response: AxiosResponse) => {
          resolve(response.data.data.inscriptionsOffreCours)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }

  protected service_inscriptionLieuExamenService_fetchTypesInscriptionsOffreCours(): Promise<Array<ITypeInscriptionLieuExamen>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_UPDATE_TYPE_INSCRIPTION_LIEU_EXAMEN_LOADING_STATE, true)

      this.$axios.get(`/api/inscriptions-lieu-examen/types-inscription-lieu-examen`)
        .then((response: AxiosResponse) => {
          const typesInscriptionLieuExamen: Array<ITypeInscriptionLieuExamen> = response.data.data.typeInscriptionLieuExamen

          this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_STORE_TYPES_INSCRIPTION_LIEU_EXAMEN, typesInscriptionLieuExamen)

          resolve(typesInscriptionLieuExamen)
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
        .finally(() => {
          this.$store.dispatch(STORE_ACTIONS.INSCRIPTION_LIEU_EXAMEN_UPDATE_TYPE_INSCRIPTION_LIEU_EXAMEN_LOADING_STATE, false)
        })
    })
  }

  protected service_inscriptionLieuExamenService_fetchFormInscriptionsOffreCours(token: string): Promise<Array<IFormInscriptionOffreCours>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.get(`/api/inscriptions-lieu-examen/dossier/${token}/formulaire-inscriptions`)
        .then((response: AxiosResponse) => {
          resolve([
            ...response.data.data.inscriptionsOffreCours,
            ...response.data.data.casSpeciaux
          ])
        }).catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }

  protected service_inscriptionLieuExamenService_saveInscriptionsAsToutCampus(token: string): Promise<void> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.post(`/api/inscriptions-lieu-examen/dossier/${token}/sauvegarde-inscriptions/campus-ul`)
        .then(() => resolve())
        .catch((error: AxiosError) => this.service_base_defaultErrorHandler(error, reject))
    })
  }

  protected service_inscriptionLieuExamenService_saveFormInscriptionsOffreCours(
    token: string,
    requestPayload: Array<IUpdateInscriptionLieuExamenRequestPayload>
  ): Promise<Array<IFormInscriptionOffreCours>> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.put(`/api/inscriptions-lieu-examen/dossier/${token}/sauvegarde-inscriptions`, {
        inscriptionsLieuExamen: requestPayload
      }).then((response: AxiosResponse) => {
          EventBus.$emit(EVENTS.AFTER_UPDATE)
          resolve(response.data.data.inscriptionsOffreCours)
        }).catch((error: AxiosError) => reject(error))
    })
  }
}